import React from 'react';

export const Delete = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M3 6H5H21" stroke="#3D3935" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V18C19 19.0609 18.5786 20.0783 17.8284 20.8284C17.0783 21.5786 16.0609 22 15 22H5V6H19Z" stroke="#3D3935" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M10 11V17" stroke="#3D3935" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    <path d="M14 11V17" stroke="#3D3935" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
